import { partial } from 'filesize'

export const filesize = partial({ base: 2, standard: 'jedec', fullform: false })
